// Intentionally divergent — see /COMPONENT-DIVERGENCE.md for rationale
//
// The variant table lives beside the component rather than inside it: a module
// that exports both a component and a plain value cannot be hot-reloaded as a
// component, and Fast Refresh says so on every lint run.
import { cva, type VariantProps } from 'class-variance-authority';

export const badgeVariants = cva(
  'inline-flex items-center rounded-xl border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-primary text-primary-foreground',
        secondary: 'border-transparent bg-secondary text-secondary-foreground',
        destructive: 'border-transparent bg-destructive text-destructive-foreground',
        outline: 'text-foreground',
        success: 'border-transparent bg-success-subtle text-success',
        warning: 'border-transparent bg-warning-subtle text-warning-foreground',
        info: 'border-transparent bg-info-subtle text-info',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
)

/** One of the badge looks, for code that picks a variant before rendering. */
export type BadgeVariant = NonNullable<VariantProps<typeof badgeVariants>['variant']>

